import i18n from '@/i18n';

export default [
  {
    path: '/promotions/deals/:id(\\d+)',
    redirect: to => ({ name: 'promotable-deals', query: { id: to.params.id } }),
  },
  {
    path: '/promotable-deals',
    name: 'promotable-deals',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'ad-manager.order',
          actions: ['view-business-contact'],
        },
      ],
      title: i18n.global.t('promotable_deals')
    },
    // route level code-splitting
    component: () => import('../../views/promotions/PromotionsDeals'),
  },
  {
    path: '/promotions-archived',
    name: 'promotions-archived',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'ad-manager.order',
          actions: ['view-nav-link'],
        },
      ],
      title: i18n.global.t('archived_promotions')
    },
    // route level code-splitting
    component: () =>
      import('../../views/promotions/PromotionsArchived'),
  },
  {
    path: '/promotions',
    name: 'promotions',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'ad-manager.order',
          actions: ['view-nav-link'],
        },
      ],
      title: i18n.global.t('promotions')
    },
    // route level code-splitting
    component: () =>
      import('../../views/promotions/Index.vue'),
    children: [
      {
        path: 'new',
        name: 'promotions-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'ad-manager.order',
              actions: ['view-nav-link'],
            },
          ],
          title: i18n.global.t('promotions')
        },
        component: () => import('../../views/promotions/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'promotion-details',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'ad-manager.order',
              actions: ['view-nav-link'],
            },
          ],
          title: i18n.global.t('promotion_details')
        },
        component: () => import('../../views/promotions/Detail.vue'),
        children: [
          {
            path: 'ads/new',
            name: 'promotion-line-item-new',
            meta: {
              loadState: true,
              auth: true,
              isAuthPage: false,
              permissions: [
                {
                  subject: 'ad-manager.order',
                  actions: ['view-nav-link'],
                },
              ],
              title: i18n.global.t('promotion_details'),
            },
            component: () => import('../../views/promotions/AddLineItem.vue'),
          },
          {
            path: 'ads/:lineId(\\d+)',
            name: 'promotion-line-item-edit',
            meta: {
              loadState: true,
              auth: true,
              isAuthPage: false,
              permissions: [
                {
                  subject: 'ad-manager.order',
                  actions: ['view-nav-link'],
                },
              ],
              title: i18n.global.t('promotion_details'),
            },
            component: () => import('../../views/promotions/EditLineItem.vue'),
          },
        ],
      },
    ],
  },
];
